/** Shared copy and styles for Meta WhatsApp template automations (Actions). */

export const AUTOMATION_TEMPLATE_UI = {
  configureTitle: 'Configurar plantillas',
  configureDescription:
    'Selecciona plantillas aprobadas en Meta y define el mapeo de variables. Requiere WhatsApp conectado en Configuración.',
  campaignConfigureDescription:
    'Configura plantilla y variables por formulario instantáneo. Las plantillas se eligen al vincular cada formulario, no hace falta listarlas aparte.',
  meetingConfigureDescription:
    'Asigna plantillas aprobadas a los recordatorios pre y post visita.',
  addTemplateButton: 'Agregar plantilla',
  editTemplateButton: 'Editar plantilla',
  metaDisabledMessage:
    'La integración con Meta no está disponible en este entorno. Puedes revisar la interfaz, pero no podrás cargar plantillas hasta que esté activa.',
  whatsappRequiredMessage:
    'Conecta WhatsApp en Configuración para cargar plantillas de Meta y enviar mensajes.',
  facebookRequiredMessage:
    'Conecta Facebook en Configuración para ver formularios instantáneos y campañas.',
  facebookReconnectRequiredMessage:
    'Reconecta Messenger en Configuración para cargar formularios instantáneos y campañas.',
  settingsLinkLabel: 'Ir a Configuración',
  serviceUnavailableMessage:
    'El servicio de plantillas no está disponible en este entorno. Prueba en QA o producción cuando el despliegue esté actualizado.',
  templatesLoadingMessage: 'Cargando plantillas…',
  templatesEmptyMessage:
    'No hay plantillas aprobadas disponibles en la cuenta de WhatsApp conectada.',
  emptyTemplatesHint: (actionLabel: string) =>
    `Aún no hay plantillas configuradas. Usa «${actionLabel}» para elegir una plantilla de Meta.`,
} as const

export const META_TEMPLATE_ALERT_CLASS =
  'border-warning/30 bg-warning/10 text-warning'
